import axios from "axios";
import { baseUrl } from "../../Config/baseUrl";

export const GetKYCList = async (req) => {
  try {
    const response = await axios.get(`${baseUrl}/blog/admin-kyc-list-api/`, {
      params: req,
      headers: {
        Authorization: `Token ${localStorage.getItem("token")}`,
      },
    });
    return response;
  } catch (err) {
    throw new Error(err);
  }
};

export const PostKYCList = async (reqbody) => {
  try {
    const response = await axios.post(
      `${baseUrl}/blog/admin-kyc-enable-disable-list-api/`,
      reqbody,
      {
        headers: {
          Authorization: `Token ${localStorage.getItem("token")}`,
        },
      }
    );
    return response;
  } catch (err) {       
    throw new Error(err);
  }
};
